<script>
import BaseButton from '@/components/general/_base-button.vue'
import BaseMixin from '@/mixins/baseMixin.js'
import ScheduleExceptionCard from './schedule-exception-card.vue'

export default {
  name: 'ScheduleExceptions',

  components: {
    ScheduleExceptionCard,
    BaseButton,
  },
  mixins: [BaseMixin],

  props: {
    locationId: {
      type: Number,
      required: true,
    },
    clientId: {
      type: Number,
      required: true,
    },
    schedule: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasExceptions() {
      return !!this.schedule?.scheduleExceptions?.length
    },
  },
}

// TODO: Make transition delay only occur on card leave not card enter as it doesnt work as intended, cards should make room for entering element
</script>

<template>
  <transition name="fast-fade" mode="out-in">
    <v-card v-if="hasExceptions" class="rounded-lg transparent px-6" flat>
      <v-card-title class="pt-6 pb-2 pl-0">
        <v-icon left :color="isDarkMode ? 'warning' : 'secondary'" class="mr-2"
          >mdi-calendar-clock</v-icon
        >
        <span class="text-body-1 font-weight-medium">{{
          $t('client.schedule.exception.importantDatesTitle')
        }}</span>
        <v-spacer />
        <BaseButton
          class="px-4"
          size="sm"
          :color="isDarkMode ? 'warning' : 'secondary'"
          outlined
          @click="$emit('open-upsert-exception')"
          >{{ $t('client.schedule.addDate') }}</BaseButton
        >
      </v-card-title>

      <transition-group
        name="fade-down-list"
        class="p-relative w-100 ws-nowrap overflow-x-auto py-2"
        tag="div"
      >
        <ScheduleExceptionCard
          v-for="{ dateLocal, ...exception } in schedule.scheduleExceptions"
          :id="exception.id"
          :key="exception.id"
          :title="exception.title"
          :date-local="dateLocal"
          :img="exception.img"
          :location-id="locationId"
          :client-id="clientId"
          @edit-exception="() => $emit('open-upsert-exception', exception.id)"
          @remove-exception="() => $emit('remove-exception', exception.id)"
        />
      </transition-group>
    </v-card>
    <div v-else class="px-6 my-12 text-center">
      <p class="mb-6">
        <v-icon left :color="isDarkMode ? 'warning' : 'secondary'" class="mr-2"
          >mdi-calendar-clock</v-icon
        >
        <span class="text-body-1 font-weight-medium">{{
          $t('client.schedule.exception.importantDatesTitle')
        }}</span>
      </p>
      <p class="text-body-1 mx-auto mb-6" style="width: 400px">{{
        $t('client.schedule.exception.noDatesFound')
      }}</p>
      <BaseButton
        outlined
        :color="isDarkMode ? 'warning' : 'secondary'"
        @click="$emit('open-upsert-exception')"
        >{{ $t('client.schedule.addDate') }}</BaseButton
      >
    </div>
  </transition>
</template>

<style lang="scss">
@import '@/scss/_vue-transitions.scss';
</style>
